/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResidentVitalsResponse } from './ResidentVitalsResponse';
import {
    ResidentVitalsResponseFromJSON,
    ResidentVitalsResponseFromJSONTyped,
    ResidentVitalsResponseToJSON,
} from './ResidentVitalsResponse';

/**
 * 
 * @export
 * @interface FindAllResidentVitalsV2200Response
 */
export interface FindAllResidentVitalsV2200Response {
    /**
     * 
     * @type {ResidentVitalsResponse}
     * @memberof FindAllResidentVitalsV2200Response
     */
    data?: ResidentVitalsResponse;
}

/**
 * Check if a given object implements the FindAllResidentVitalsV2200Response interface.
 */
export function instanceOfFindAllResidentVitalsV2200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllResidentVitalsV2200ResponseFromJSON(json: any): FindAllResidentVitalsV2200Response {
    return FindAllResidentVitalsV2200ResponseFromJSONTyped(json, false);
}

export function FindAllResidentVitalsV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllResidentVitalsV2200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ResidentVitalsResponseFromJSON(json['data']),
    };
}

export function FindAllResidentVitalsV2200ResponseToJSON(value?: FindAllResidentVitalsV2200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ResidentVitalsResponseToJSON(value.data),
    };
}

